// ── Seen-version sync ────────────────────────────────────────────────────────
// WhatsNew.jsx's "seen version" flag (nextep_seen_version) was localStorage-only,
// never synced to the account — same bug class as coachmarks (see coachmarks.js,
// 2026-08-17): a fresh login (cleared cache, new device, or safeStorage's
// in-memory fallback resetting on reload when real localStorage is blocked)
// replayed the toast + full changelog sheet for a version already seen.
//
// Lives in its own file (not inside WhatsNew.jsx, which is lazy-loaded off the
// entry chunk) so useAuth.jsx — very much an entry-chunk module — can import
// syncSeenVersionFromProfile() without dragging WhatsNew's component code back
// into the eager bundle.
import { safeStorage } from './safeStorage'
import { supabase } from './supabase'

export const SEEN_KEY = 'nextep_seen_version'

export function markVersionSeen(version) {
  try { safeStorage.set(SEEN_KEY, version) } catch { /* non-fatal */ }
  try { supabase.rpc('mark_version_seen', { p_version: version }).then(() => {}, () => {}) } catch { /* non-fatal */ }
}

// Dotted version strings ("16.061") compared numerically segment-by-segment.
function versionGte(a, b) {
  const pa = String(a).split('.').map(Number), pb = String(b).split('.').map(Number)
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const x = pa[i] || 0, y = pb[i] || 0
    if (x !== y) return x > y
  }
  return true
}

// Called once when the profile loads (useAuth.jsx) — pulls the account's
// highest-seen version (any device) into this device's localStorage, so a fresh
// login doesn't replay a changelog already seen elsewhere. Never regresses a
// device that's already ahead locally (e.g. mid-session, before the RPC round
// trip lands).
export function syncSeenVersionFromProfile(profile) {
  const remote = profile?.ui_prefs?.seen_version
  if (!remote || typeof remote !== 'string') return
  try {
    const local = safeStorage.get(SEEN_KEY)
    if (!local || versionGte(remote, local)) safeStorage.set(SEEN_KEY, remote)
  } catch { /* non-fatal */ }
}
